// Which slots of an approval request this caller may sign.
//
// ONE FUNCTION, USED BY BOTH SURFACES. There were two: `openSlots` on the record's Approval tab and
// `signableSlots` in the queue. They were meant to say the same thing and did not -- the queue's
// copy checked neither the request status nor CanSign, so it offered "Sign as Reviewed" on a
// WITHDRAWN request, to somebody who could not sign it.
//
// That is exactly the divergence the shared signing dialog exists to prevent, reintroduced one file
// away from it. Two implementations of one rule do not stay equal; the second one is always the one
// nobody remembers to update.

type Row = Record<string, any>;

export function signableSlots(request: Row | null) {
    if (!request || request.Status !== "PENDING") return [];
    return (request.Slots ?? []).filter((slot: Row) =>
        slot.Stage === request.CurrentStage
        && !slot.Signature
        // CanSign COMES FROM THE SERVER, which is the only thing that knows the caller's personas
        // and the rules that go with them -- author-exclusion and distinctness included.
        && slot.CanSign);
}
